// extracted by css-extract-rspack-plugin
export default {"container":"PlanTypeSegmentedControl-module__container__GebOB","segment":"PlanTypeSegmentedControl-module__segment__AZAo9"};